var _defs, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 290.25 135",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-17,.cls-19,.cls-2,.cls-38,.cls-72,.cls-85,.cls-86,.cls-87,.cls-90{fill:none;}.cls-1{clip-rule:evenodd;}.cls-3{fill:#f9f6fd;}.cls-15,.cls-4{fill:#fff;}.cls-4{opacity:0.8;}.cls-32,.cls-5{fill:#e9e2f4;}.cls-16,.cls-6{fill:#e6e4e9;}.cls-6,.cls-84{opacity:0.5;}.cls-18,.cls-7,.cls-84{fill:#6a5d84;}.cls-8{fill:#aba3ba;}.cls-9{fill:#7e57c2;}.cls-10{fill:#cbbce7;}.cls-11{fill:#ffe237;}.cls-12,.cls-14{fill:#f5cf34;}.cls-13{fill:#fff2ad;}.cls-14,.cls-18{opacity:0.2;}.cls-16,.cls-76{opacity:0.25;}.cls-17,.cls-86{stroke:#fff2ad;}.cls-17,.cls-38,.cls-85,.cls-87{stroke-linecap:round;}.cls-17,.cls-19,.cls-38,.cls-72,.cls-85,.cls-86,.cls-90{stroke-miterlimit:10;}.cls-19{stroke:#363145;}.cls-20{clip-path:url(#clip-path);}.cls-21{clip-path:url(#clip-path-2);}.cls-22{isolation:isolate;}.cls-23{clip-path:url(#clip-path-3);}.cls-24{clip-path:url(#clip-path-4);}.cls-25{fill:#f8f6fc;}.cls-26{clip-path:url(#clip-path-5);}.cls-27{clip-path:url(#clip-path-7);}.cls-28{clip-path:url(#clip-path-9);}.cls-29{clip-path:url(#clip-path-10);}.cls-30{fill:#cdc7d5;}.cls-31{clip-path:url(#clip-path-11);}.cls-32{opacity:0.9;}.cls-33{clip-path:url(#clip-path-13);}.cls-34{clip-path:url(#clip-path-15);}.cls-35{clip-path:url(#clip-path-16);}.cls-36{fill:#b0a8be;}.cls-37{clip-path:url(#clip-path-17);}.cls-38{stroke:#e9e2f4;stroke-width:3px;}.cls-39{clip-path:url(#clip-path-20);}.cls-40{clip-path:url(#clip-path-22);}.cls-41{clip-path:url(#clip-path-24);}.cls-42{clip-path:url(#clip-path-26);}.cls-43{clip-path:url(#clip-path-28);}.cls-44{clip-path:url(#clip-path-30);}.cls-45{clip-path:url(#clip-path-31);}.cls-46{fill:#ffe24f;}.cls-47{clip-path:url(#clip-path-32);}.cls-48{fill:#ffc34f;}.cls-49{clip-path:url(#clip-path-34);}.cls-50{clip-path:url(#clip-path-36);}.cls-51{fill:#ff4f4f;}.cls-52{clip-path:url(#clip-path-38);}.cls-53{clip-path:url(#clip-path-40);}.cls-54,.cls-62{fill:#786d90;}.cls-54{opacity:0.22;}.cls-55{clip-path:url(#clip-path-42);}.cls-56{clip-path:url(#clip-path-44);}.cls-57{clip-path:url(#clip-path-46);}.cls-58{clip-path:url(#clip-path-47);}.cls-59{clip-path:url(#clip-path-48);}.cls-60{clip-path:url(#clip-path-50);}.cls-61{clip-path:url(#clip-path-52);}.cls-63{clip-path:url(#clip-path-54);}.cls-64{clip-path:url(#clip-path-56);}.cls-65{clip-path:url(#clip-path-58);}.cls-66{clip-path:url(#clip-path-60);}.cls-67{clip-path:url(#clip-path-62);}.cls-68{clip-path:url(#clip-path-64);}.cls-69{clip-path:url(#clip-path-66);}.cls-70{opacity:0.4;}.cls-71{clip-path:url(#clip-path-68);}.cls-72{stroke:#b3b0b7;}.cls-73{fill:#3eb378;}.cls-74{fill:#c63e3e;}.cls-75{fill:#6734ba;}.cls-75,.cls-78{opacity:0.6;}.cls-76{fill:#bdbbbb;}.cls-77{fill:#363145;}.cls-78{fill:#4c4c4c;}.cls-79{fill:#ff6363;}.cls-80{fill:#a03737;}.cls-81{fill:#44b983;}.cls-82{fill:#318e5f;}.cls-83{fill:#52de9d;}.cls-85{stroke:#7e57c2;}.cls-85,.cls-86{stroke-width:0.5px;}.cls-87{stroke:#cdc7d5;stroke-linejoin:round;}.cls-88{opacity:0.54;}.cls-89{clip-path:url(#clip-path-69);}.cls-90{stroke:#f9e698;}.cls-91{opacity:0.22;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M247.56,71.31a13.77,13.77,0,1,0-27.53,0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 206.47,
    y: 50.11,
    width: 49.56,
    height: 53.14
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 213.36,
    y: 56.86,
    width: 48.04,
    height: 24.09
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 219.96,
    y: 57.54,
    width: 27.67,
    height: 13.77
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 236.9,
    cy: 63.4,
    r: 2.75
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.2,80c5.37,0,27.44-4.14,27.44-9.18s9.49-7.36,4.12-7.36-29.76.31-29.76,0S211.83,80,217.2,80Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-9"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 214.46,
    y: 62.64,
    width: 36.76,
    height: 18.03
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-10"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 219.96,
    y: 63.05,
    width: 27.67,
    height: 8.26
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.5,67.68q-3.44-3.36.28-4.94a2.92,2.92,0,0,1,.66,0c-2.74,2.2-.09,2.53.59,3.53S238.28,67.85,236.5,67.68Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M245.23,80.18c5.32.74,10.19-2.69,10.9-7.68s7.58-9.53,2.27-10.28-43.54,7.3-44.25,12.29S239.91,79.43,245.23,80.18Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 212.94,
    y: 55.48,
    width: 48.46,
    height: 28.63
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-16"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 219.96,
    y: 61.4,
    width: 27.67,
    height: 9.91
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M244.69,72.42h-9.25V75.3c-1.82-.83-2.49-2.08,0-2.93q6.65-2.25-.15-8.6a8.5,8.5,0,0,1,1.32-.72c5,3.1,8.09,5.53,8.09,9C244.7,72.18,244.7,72.3,244.69,72.42Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.16,68.88h4v1.78a.42.42,0,0,1-.42.42h-2.48a.42.42,0,0,1-.39-.28Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.46,68.88h4v1.78a.41.41,0,0,1-.41.42h-2.48a.41.41,0,0,1-.39-.28Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.48,68.88h4v1.78a.41.41,0,0,1-.41.42h-2.48a.42.42,0,0,1-.39-.28Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M221.14,71.08c-.42,0-.75-1-.75-2.16s.33-2.15.75-2.15.75,1,.75,2.15S221.55,71.08,221.14,71.08Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.57,59.33H221.8a.54.54,0,0,0-.48.29,37.07,37.07,0,0,1-2.1,3.54c-.73.36-.55.09-1.31,1a8.27,8.27,0,0,0-.9,3.54c0,1.1.12,1.39.39,1.72.11.13.54.34,2.41.41.85,0,2.59,0,5.2,0,3.06,0,5,0,5.87,0a6.46,6.46,0,0,0,2.75-.41c.27-.33.38-.62.38-1.72a8.13,8.13,0,0,0-.9-3.54c-.76-.91-1.09-.64-1.82-1q-.42-.51-2.49-3.58a.58.58,0,0,0-.46-.25Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-30"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 216.25,
    y: 58.65,
    width: 18.58,
    height: 11.98
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-31"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 216.93,
    y: 59.33,
    width: 17.21,
    height: 10.6
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-32"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 216.41,
    y: 68.44,
    width: 17.6,
    height: 1.38
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-34"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 221.06,
    y: 67.67,
    width: 3,
    height: 1.5,
    rx: 0.28
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-36"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 224.38,
    y: 65.25,
    width: 3,
    height: 1.38,
    rx: 0.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-38"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 217.62,
    y: 65.25,
    width: 3,
    height: 1.38,
    rx: 0.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M220.63,65.94h-3v.14a.55.55,0,0,0,.55.55h1.91a.55.55,0,0,0,.55-.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M227.38,65.94h-3v.14a.55.55,0,0,0,.55.55h1.9a.55.55,0,0,0,.55-.55Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M226.32,60.39a.64.64,0,0,1-.07-.27.55.55,0,0,1,.55-.55h.26l2.21,3.6H228a.29.29,0,0,1-.24-.14Zm1-.82h1.06a.55.55,0,0,1,.47.26l1.8,2.92a.33.33,0,0,1,0,.14.29.29,0,0,1-.28.28h-.92Zm-.34,3.2a.27.27,0,0,1,0,.12.28.28,0,0,1-.28.28h-6.52a.23.23,0,0,1-.14,0,.27.27,0,0,1-.1-.37l1.62-2.91a.56.56,0,0,1,.48-.28h3a.54.54,0,0,1,.49.31Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-46"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 215.83,
    y: 58.78,
    width: 17.9,
    height: 10.74
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-47"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 219.83,
    y: 59.47,
    width: 11.01,
    height: 3.72
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-48"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 229.07,
    cy: 64.94,
    r: 4.55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-50"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 219.46,
    cy: 63.4,
    r: 3.52
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-52"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 233.26,
    cy: 68.92,
    rx: 0.75,
    ry: 2.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-54"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 229.95,
    cy: 68.92,
    rx: 0.75,
    ry: 2.15
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-56"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M233.26,70.14c-.21,0-.38-.55-.38-1.22s.17-1.22.38-1.22.37.55.37,1.22S233.46,70.14,233.26,70.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-58"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230,70.14c-.21,0-.37-.55-.37-1.22s.16-1.22.37-1.22.38.55.38,1.22S230.16,70.14,230,70.14Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-60"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 231.13,
    y: 62.33,
    width: 1.79,
    height: 1.24,
    rx: 0.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-62"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 230.99,
    y: 62.33,
    width: 1.65,
    height: 1.24,
    rx: 0.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-64"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 231.13,
    y: 62.47,
    width: 1.38,
    height: 0.96,
    rx: 0.21
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-66"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M231.85,62.89a.72.72,0,0,0-.53-.18.21.21,0,0,0-.19.2v.31a.21.21,0,0,0,.21.21h.82A1,1,0,0,0,231.85,62.89Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-68"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M233.76,117.9H158.59l-4.34,8h83.84Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-69"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 52.84,
    cy: 93.57,
    rx: 20.21,
    ry: 3.35
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "home") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background-2",
    "data-name": "background"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M271.32,131.57a126.2,126.2,0,0,0-252.39,0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Lamp"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.07,34.49s10.75,50.81-34.55,31C86.72,44.09,49.47,89,18.93,129.4H264.78s-123,11.09-121.13-18.35,87.51-27.5,38.45-76.56Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M170.07,34.49s-12.19,45.08-61,37.08c-52-8.53-84.24,22.32-90.15,56.75H242.31s-85.71,12.34-83.82-17.11,32-37.22,23.61-76.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M185.46,39.51a9.21,9.21,0,0,1-1.2,4.59,9.38,9.38,0,0,1-8.18,4.81,9.28,9.28,0,0,1-2.48-.34,9.5,9.5,0,0,1-5.69-4.47,9.22,9.22,0,0,1-1.21-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M185.46,39.51a9.21,9.21,0,0,1-1.2,4.59H167.91a9.22,9.22,0,0,1-1.21-4.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M175.56,1.59l.46-.26.66.31,0,26.48H175.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M178.46,31.26H173.7V27.83A1.34,1.34,0,0,1,175,26.49h2.09a1.33,1.33,0,0,1,1.33,1.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M180.6,34.81h-9V32.32a2.88,2.88,0,0,1,2.88-2.88h3.28a2.88,2.88,0,0,1,2.88,2.88v2.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M188.42,42.92H163.74a.42.42,0,0,1-.42-.43v-.43a9.33,9.33,0,0,1,9.32-9.33h6.88a9.33,9.33,0,0,1,9.33,9.33v.43A.43.43,0,0,1,188.42,42.92Z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "floor"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M269,128.36H2.06A2.14,2.14,0,0,1,0,126.15H0A2.13,2.13,0,0,1,2.06,124H269a2.14,2.14,0,0,1,2.07,2.2h0A2.15,2.15,0,0,1,269,128.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M288.16,132.78H17.56a2.15,2.15,0,0,1-2.09-2.21h0a2.15,2.15,0,0,1,2.09-2.21h270.6a2.16,2.16,0,0,1,2.09,2.21h0A2.16,2.16,0,0,1,288.16,132.78Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Sofa"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 90.09,
    y: 96.82,
    width: 109.45,
    height: 17.45
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 93.18,
    y: 74.94,
    width: 103.1,
    height: 27.9
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 89.96,
    y: 71.96,
    width: 54.77,
    height: 30.31,
    rx: 6
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M198,108.92v13.83l-4.16,1.57h-97l-.76-.28v-13.4c0-1,1.25-1.72,2.78-1.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M102.07,104.82,86.82,118.58l-5-9.36V96.79a5,5,0,0,1,1.48-3.66c3.06-2.82,6.38-6,6.67-6a11.87,11.87,0,0,1,9.6,5.17C102.07,95.72,105.15,102,102.07,104.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M96.81,113v11.3l-15-.4V96c0-1.4,1-2.45,2-2.27,7,1.23,12.44,8.7,12.94,17.92C96.8,112.08,96.81,112.55,96.81,113Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 145.93,
    y: 71.96,
    width: 54.77,
    height: 30.31,
    rx: 6,
    transform: "translate(346.62 174.23) rotate(-180)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M188.58,104.82l15.25,13.76,5-9.36V96.79a5,5,0,0,0-1.47-3.66c-3.07-2.82-6.39-6-6.67-6a11.85,11.85,0,0,0-9.6,5.17C188.59,95.72,185.51,102,188.58,104.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M193.84,113v11.3l15-.4V96c0-1.4-1-2.45-2-2.27-7,1.23-12.44,8.7-13,17.92C193.86,112.08,193.84,112.55,193.84,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M121.1,102.92l-14.89,3a4.35,4.35,0,0,1-3.78-1,4.3,4.3,0,0,1-1.42-2.44L98,87.53a4.41,4.41,0,0,1,3.46-5.19l10.26-2,4.64-.93a4.42,4.42,0,0,1,5.2,3.47l3,14.89A4.42,4.42,0,0,1,121.1,102.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M190.74,87.53l-3,14.91a4.41,4.41,0,0,1-5.2,3.45l-14.89-3a4.21,4.21,0,0,1-1.83-.83,4.39,4.39,0,0,1-1.64-4.36l3-14.89a4.42,4.42,0,0,1,5.2-3.47l14.89,3a4.5,4.5,0,0,1,.94.3A4.41,4.41,0,0,1,190.74,87.53Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M83.62,93.89a12.77,12.77,0,0,1,4.31,1.37,15.88,15.88,0,0,1,3.62,2.8,19.27,19.27,0,0,1,2.72,3.7A21.59,21.59,0,0,1,96,106a24.61,24.61,0,0,1,.89,4.49c0,.77.12,1.53.09,2.29l0,2.27-.14,4.49c-.09,1.5-.14,3-.25,4.5-.11-1.5-.16-3-.24-4.5L96.2,115c0-.75,0-1.49,0-2.23s-.11-1.47-.16-2.21a25.39,25.39,0,0,0-.9-4.31,21.07,21.07,0,0,0-4.1-7.7A14.65,14.65,0,0,0,83.62,93.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M206.83,93.89a14.56,14.56,0,0,0-7.37,4.69,20.92,20.92,0,0,0-4.1,7.7,24.46,24.46,0,0,0-.9,4.31c-.05.74-.16,1.47-.16,2.21s0,1.48-.05,2.23l-.14,4.51c-.08,1.5-.13,3-.24,4.5-.12-1.5-.17-3-.25-4.5l-.14-4.49-.06-2.27c0-.76.07-1.52.1-2.29a24.59,24.59,0,0,1,.88-4.49,22.21,22.21,0,0,1,1.77-4.24,19.7,19.7,0,0,1,2.72-3.7,16.32,16.32,0,0,1,3.62-2.8A12.9,12.9,0,0,1,206.83,93.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M121.1,102.92l-14.89,3a4.35,4.35,0,0,1-3.78-1,26.95,26.95,0,0,0,9.33-24.58l4.64-.93a4.42,4.42,0,0,1,5.2,3.47l3,14.89A4.42,4.42,0,0,1,121.1,102.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M132.79,99.36a4.66,4.66,0,0,1-4.24,5l-13.46,1.16a4.61,4.61,0,0,1-2.91-.73,4.43,4.43,0,0,1-.69-.54,4.67,4.67,0,0,1-1.44-3l-.76-8.92a4.64,4.64,0,0,1,4.23-5L127,86.18h.07a4.58,4.58,0,0,1,3,.81,4.68,4.68,0,0,1,2,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M132.79,99.36a4.66,4.66,0,0,1-4.24,5l-13.46,1.16a4.61,4.61,0,0,1-2.91-.73,4.43,4.43,0,0,1-.69-.54,20.3,20.3,0,0,0,15.57-18.11,4.58,4.58,0,0,1,3,.81,4.68,4.68,0,0,1,2,3.43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M190.74,87.53l-3,14.91a4.41,4.41,0,0,1-5.2,3.45l-14.89-3a4.21,4.21,0,0,1-1.83-.83,31,31,0,0,0,22.36-19.45A4.41,4.41,0,0,1,190.74,87.53Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 99.27,
    y1: 110.19,
    x2: 99.27,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 102.94,
    y1: 110.19,
    x2: 102.94,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 106.61,
    y1: 110.19,
    x2: 106.61,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 110.28,
    y1: 110.19,
    x2: 110.28,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 113.95,
    y1: 110.19,
    x2: 113.95,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 117.61,
    y1: 110.19,
    x2: 117.61,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 121.28,
    y1: 110.19,
    x2: 121.28,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 124.95,
    y1: 110.19,
    x2: 124.95,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 128.62,
    y1: 110.19,
    x2: 128.62,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 132.29,
    y1: 110.19,
    x2: 132.29,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 135.96,
    y1: 110.19,
    x2: 135.96,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 139.63,
    y1: 110.19,
    x2: 139.63,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 143.3,
    y1: 110.19,
    x2: 143.3,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 146.97,
    y1: 110.19,
    x2: 146.97,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 150.64,
    y1: 110.19,
    x2: 150.64,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 154.31,
    y1: 110.19,
    x2: 154.31,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 157.98,
    y1: 110.19,
    x2: 157.98,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 161.65,
    y1: 110.19,
    x2: 161.65,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 165.32,
    y1: 110.19,
    x2: 165.32,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 168.99,
    y1: 110.19,
    x2: 168.99,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 172.66,
    y1: 110.19,
    x2: 172.66,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 176.33,
    y1: 110.19,
    x2: 176.33,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 179.99,
    y1: 110.19,
    x2: 179.99,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 183.66,
    y1: 110.19,
    x2: 183.66,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 187.33,
    y1: 110.19,
    x2: 187.33,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 191,
    y1: 110.19,
    x2: 191,
    y2: 112.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 97.96,
    y1: 109.55,
    x2: 192.31,
    y2: 109.55
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_11",
    "data-name": "Layer 11"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 107.46,
    cy: 34.88,
    r: 10.57
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M118,34.88a10.57,10.57,0,0,1-10.57,10.57,9.19,9.19,0,0,1-1.58-.12,10.57,10.57,0,0,0,0-20.9,10.31,10.31,0,0,1,1.58-.12A10.57,10.57,0,0,1,118,34.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M107.46,24.31A10.57,10.57,0,1,1,96.9,34.88a10.57,10.57,0,0,1,10.56-10.57m0-1A11.57,11.57,0,1,0,119,34.88a11.57,11.57,0,0,0-11.57-11.57Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-19",
    points: "108.08 41.62 107.46 34.88 107.59 34.76 110.89 31.45"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Picture_frame",
    "data-name": "Picture frame"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 214.3,
    y: 50.24,
    width: 35.99,
    height: 23.58
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-20"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-23"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 219.34,
    y: 56.86,
    width: 28.91,
    height: 15.14
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-26"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 233.45,
    y: 59.95,
    width: 6.88,
    height: 6.88
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-27"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-28"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-30",
    x: 214.52,
    y: 62.74,
    width: 36.58,
    height: 17.92
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-32",
    x: 234.18,
    y: 62.06,
    width: 4.82,
    height: 6.37,
    transform: "translate(-2.13 8.3) rotate(-2)"
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-33"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-34"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-36",
    x: 226.01,
    y: 46.98,
    width: 22.33,
    height: 45.67,
    transform: "translate(135.03 294.97) rotate(-82)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-37"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-35"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 233.13,
    y: 62.36,
    width: 12.27,
    height: 13.62
  }))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-38",
    x1: 247.31,
    y1: 71.26,
    x2: 224.06,
    y2: 71.26
  })))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-39"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 225.47,
    y: 68.19,
    width: 5.37,
    height: 3.57
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-40"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 228.77,
    y: 68.19,
    width: 5.37,
    height: 3.57
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-41"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 216.8,
    y: 68.19,
    width: 5.37,
    height: 3.57
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-42"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 219.7,
    y: 66.08,
    width: 2.87,
    height: 5.68
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-43"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-44"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 216.33,
    y: 58.65,
    width: 18.38,
    height: 11.9
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-47"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 215.72,
    y: 67.76,
    width: 18.98,
    height: 2.75
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-49"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 220.38,
    y: 66.98,
    width: 4.37,
    height: 2.87
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-50"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 223.69,
    y: 64.57,
    width: 4.38,
    height: 2.75
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-52"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 216.93,
    y: 64.57,
    width: 4.38,
    height: 2.75
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-53"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 216.93,
    y: 65.25,
    width: 4.38,
    height: 2.06
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-55"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 223.69,
    y: 65.25,
    width: 4.38,
    height: 2.06
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-56"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-45"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-57"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 219.28,
    y: 58.88,
    width: 12.13,
    height: 4.97
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-59"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 223.84,
    y: 59.71,
    width: 10.47,
    height: 10.47
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-60"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-58"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 215.25,
    y: 59.19,
    width: 8.41,
    height: 8.41
  }))))))))))), /*#__PURE__*/React.createElement("g", {
    className: "cls-61"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 231.82,
    y: 66.08,
    width: 2.87,
    height: 5.68
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-63"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-62",
    x: 228.51,
    y: 66.08,
    width: 2.87,
    height: 5.68
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-64"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 232.19,
    y: 67.02,
    width: 2.13,
    height: 3.81
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-65"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 228.89,
    y: 67.02,
    width: 2.13,
    height: 3.81
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-66"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 230.44,
    y: 61.64,
    width: 3.17,
    height: 2.62
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-67"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-48",
    x: 230.3,
    y: 61.64,
    width: 3.03,
    height: 2.62
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-68"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-15",
    x: 230.44,
    y: 61.78,
    width: 2.75,
    height: 2.34
  }))), /*#__PURE__*/React.createElement("g", {
    className: "cls-69"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 230.44,
    y: 62.02,
    width: 2.41,
    height: 2.1
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M248.28,52.24V71.82h-32V52.24h32m2-2h-36V73.82h36V50.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M250.28,50.24V73.82h-36V50.24h36m2-2h-40V75.82h40V48.24Z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "table"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M169.86,127l-3.35,6.56a.57.57,0,0,1-.51.28h-1.33a.5.5,0,0,1-.55-.49l.64-6.25a.55.55,0,0,1,.62-.41h3.71C169.45,126.76,170,126.75,169.86,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M222.48,127l3.36,6.56a.56.56,0,0,0,.51.28h1.33a.51.51,0,0,0,.55-.49l-.65-6.25a.55.55,0,0,0-.62-.41h-3.7C222.89,126.76,222.34,126.75,222.48,127Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M233.76,117.9H158.59l-4.34,8h83.84Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 154.25,
    y: 125.9,
    width: 83.84,
    height: 2.4
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-70"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-71"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 249.05,
    y1: 118.23,
    x2: 216.3,
    y2: 135.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 244.45,
    y1: 117.94,
    x2: 212.12,
    y2: 134.75
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 239.84,
    y1: 117.66,
    x2: 207.93,
    y2: 134.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 235.23,
    y1: 117.38,
    x2: 203.74,
    y2: 133.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 230.63,
    y1: 117.09,
    x2: 199.56,
    y2: 133.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 226.02,
    y1: 116.81,
    x2: 195.37,
    y2: 132.74
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 221.41,
    y1: 116.52,
    x2: 191.18,
    y2: 132.24
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 216.8,
    y1: 116.24,
    x2: 186.99,
    y2: 131.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 212.2,
    y1: 115.96,
    x2: 182.81,
    y2: 131.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 207.59,
    y1: 115.67,
    x2: 178.62,
    y2: 130.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 202.98,
    y1: 115.39,
    x2: 174.43,
    y2: 130.23
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 198.38,
    y1: 115.1,
    x2: 170.25,
    y2: 129.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 193.77,
    y1: 114.82,
    x2: 166.06,
    y2: 129.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 189.16,
    y1: 114.53,
    x2: 161.87,
    y2: 128.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 184.56,
    y1: 114.25,
    x2: 157.69,
    y2: 128.22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 179.95,
    y1: 113.97,
    x2: 153.5,
    y2: 127.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 175.34,
    y1: 113.68,
    x2: 149.31,
    y2: 127.21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-72",
    x1: 170.73,
    y1: 113.4,
    x2: 145.13,
    y2: 126.71
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.8,103.92c0,.16-.6.28-1.34.28s-1.34-.12-1.34-.28.6-.28,1.34-.28S223.8,103.77,223.8,103.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M223.8,103.92c0,.16-.6.28-1.34.28s-1.34-.12-1.34-.28.6-.28,1.34-.28S223.8,103.77,223.8,103.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M223.06,105.06a20.76,20.76,0,0,1-.15-3.44,19.82,19.82,0,0,1,.4-3.43,12.92,12.92,0,0,1,1.09-3.3,7.21,7.21,0,0,1,2.14-2.69,9.07,9.07,0,0,0-1.79,2.85,17.22,17.22,0,0,0-.95,3.24c-.24,1.1-.38,2.23-.51,3.36S223.1,103.92,223.06,105.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M229.21,92.6l.6-.73c.11-.14-.06-.41-.24-.4l-.75,0,.57-1.06c.09-.15-.11-.41-.28-.37l-1.17.28.24-.71c.06-.17-.16-.41-.32-.34l-.87.4h0l-.9.42c-.63.48-.57,1.59.11,2.48s1.74,1.23,2.36.75Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M227.67,93.57a2.08,2.08,0,0,1-1.54-.91,2,2,0,0,1-.47-1.7,2.59,2.59,0,0,0,1.1,1.19h0s0,0,0,0A2.75,2.75,0,0,0,227.67,93.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M218.46,91l-.58-.4c-.11-.07-.3.07-.27.21l.08.54-.81-.35c-.12-.06-.3.11-.26.23l.28.84-.53-.13c-.13,0-.3.15-.23.26l.34.61h0s.4.68.37.64c.39.43,1.21.32,1.82-.25s.79-1.35.39-1.78Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M219.27,92.09a1.52,1.52,0,0,1-.57,1.19,1.47,1.47,0,0,1-1.22.46,1.87,1.87,0,0,0,.8-.89h0A2,2,0,0,0,219.27,92.09Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M222.19,106.15c-.05-1.15-.12-2.28-.24-3.42a31.65,31.65,0,0,0-.5-3.36,17.12,17.12,0,0,0-.95-3.23,9.3,9.3,0,0,0-1.79-2.86,7.36,7.36,0,0,1,2.14,2.7,13,13,0,0,1,1.09,3.29,21.09,21.09,0,0,1,.4,3.44A20.81,20.81,0,0,1,222.19,106.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M225,106.69v12.43c0,.35-1.14.64-2.53.64s-2.53-.29-2.53-.64V106.69a1.59,1.59,0,0,1,.6-1.25,1.62,1.62,0,0,1,1-.38h1.8A1.63,1.63,0,0,1,225,106.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M225,117.41v1.71c0,.35-1.14.64-2.53.64s-2.53-.29-2.53-.64V106.69a1.59,1.59,0,0,1,.6-1.25,11.71,11.71,0,0,0,3.22,10.91A13.64,13.64,0,0,0,225,117.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M223.8,103.93v1.55h-2.68v-1.55c0,.15.6.27,1.34.27S223.8,104.08,223.8,103.93Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M185.23,113H170.45a.1.1,0,0,0-.09.1v.2l.06.12h0a3.16,3.16,0,0,1,.38,1.51,3.23,3.23,0,0,1-.38,1.52h0l-.06.11v.21a.09.09,0,0,0,.09.09h14.78a1.52,1.52,0,0,0,1.45-1.59v-.68A1.53,1.53,0,0,0,185.23,113Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.08,114.84v.25a1.33,1.33,0,0,1-1.27,1.39h-7.32s-.05,0,0-.06a3.34,3.34,0,0,0,.34-1.46,3.12,3.12,0,0,0-.19-1.07,2.5,2.5,0,0,0-.15-.38s0,0,0,0a0,0,0,0,1,0,0h7.32a1.2,1.2,0,0,1,.93.44A1.45,1.45,0,0,1,179.08,114.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M185.6,114.84v.25c0,.77-.42,1.39-.93,1.39h-5.35s0,0,0-.07a4.2,4.2,0,0,0,.25-1.45,4.14,4.14,0,0,0-.25-1.44s0-.07,0-.07h5.35C185.18,113.45,185.6,114.07,185.6,114.84Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M178.74,113.89h-8.13a2.5,2.5,0,0,0-.15-.38s0,0,0,0a0,0,0,0,1,0,0h7.32A1.2,1.2,0,0,1,178.74,113.89Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M186.28,116.92H170.12a.13.13,0,0,0-.11.14v.3l.08.16h0a6,6,0,0,1,.41,2.22,6.16,6.16,0,0,1-.41,2.24h0a1.3,1.3,0,0,1-.08.17v.3a.13.13,0,0,0,.11.14h16.16c.88,0,1.59-1,1.59-2.35v-1C187.87,118,187.16,116.92,186.28,116.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M179.56,119.57V120c0,1.12-.62,2-1.39,2h-8s0-.06,0-.09a6.37,6.37,0,0,0,.38-2.15,6.21,6.21,0,0,0-.21-1.58,5,5,0,0,0-.17-.55v0s0-.07,0-.07h8a1.24,1.24,0,0,1,1,.65A2.67,2.67,0,0,1,179.56,119.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M186.68,119.57v.37c0,1.13-.45,2-1,2h-5.85s0-.06,0-.1a8.35,8.35,0,0,0,.27-2.14,8.25,8.25,0,0,0-.27-2.12s0-.1,0-.1h5.85C186.23,117.53,186.68,118.44,186.68,119.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M179.18,118.17H170.3a5,5,0,0,0-.17-.55v0s0-.07,0-.07h8A1.24,1.24,0,0,1,179.18,118.17Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    id: "shelf_with_books",
    "data-name": "shelf with books"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 24.29,
    y: 47.42,
    width: 67.17,
    height: 6.08
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "88.7 55.2 21.53 55.2 24.29 53.5 91.46 53.5 88.7 55.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-51",
    x: 57.21,
    y: 22.87,
    width: 5.04,
    height: 24.55,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 62.15,
    y: 22.87,
    width: 5.04,
    height: 24.55,
    rx: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 67.18,
    y: 22.87,
    width: 2.73,
    height: 24.55,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-79",
    x: 70.91,
    y: 22.87,
    width: 2.73,
    height: 24.55,
    rx: 0.5,
    transform: "translate(-2.74 6.3) rotate(-4.9)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 58.07,
    y: 23.7,
    width: 3.31,
    height: 7.33,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 58.2,
    y: 45.16,
    width: 3.06,
    height: 0.97,
    rx: 0.38
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M60.89,45.28a.25.25,0,0,1,.25.25v.23a.26.26,0,0,1-.25.25H58.57a.25.25,0,0,1-.25-.25v-.23a.25.25,0,0,1,.25-.25h2.32m0-.25H58.57a.5.5,0,0,0-.5.5v.23a.51.51,0,0,0,.5.5h2.32a.51.51,0,0,0,.5-.5v-.23a.5.5,0,0,0-.5-.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-74",
    x: 58.07,
    y: 32.03,
    width: 3.31,
    height: 12.03,
    rx: 0.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 68.55,
    cy: 24.53,
    r: 0.83
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-51",
    cx: 71.39,
    cy: 24.53,
    r: 0.83
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 63.81,
    y: 23.84,
    width: 1.68,
    height: 20.23,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-80",
    x: 63.81,
    y: 44.75,
    width: 1.68,
    height: 1.66,
    rx: 0.71
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M37.78,26.4s-.21-1.22,1.9-2.56c0,0,.15,2.62-1.77,3.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M38,26.81a1.71,1.71,0,0,1,.24-1.16,1.81,1.81,0,0,1,.89-.79,2.74,2.74,0,0,1-.21.55,3.75,3.75,0,0,1-.25.49A5.29,5.29,0,0,1,38,26.81Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M36.8,17.91s-.07-.72,1.21-1.43c0,0,0,1.54-1.16,1.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M36.93,18.15a1.07,1.07,0,0,1,.21-.65,1.2,1.2,0,0,1,.53-.44A4,4,0,0,1,36.93,18.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M37,20.67a2.53,2.53,0,0,1,2.32-2s-.57,3.25-2.3,2.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M36.89,20.52a3.94,3.94,0,0,0-4.18-2.19s2.43,5.57,4.33,3.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M38.38,29.7s-.34-2,3.17-4.28c0,0,.25,4.38-2.95,5.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M42.27,34.17s3.59-.57,5.18-5.73c0,0-9-1.58-7.62,6.44Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-81",
    d: "M30.24,27.71s5.25,7.26,9.27,7.47C38.06,30.05,35.74,26.8,30.24,27.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M41.31,38.79a25.92,25.92,0,0,1-2.38-4.88,36.44,36.44,0,0,1-1.53-5.23,35.11,35.11,0,0,1-.74-5.39,30.76,30.76,0,0,1,.15-5.43,90.7,90.7,0,0,0,1.57,10.61c.35,1.75.8,3.47,1.29,5.19S40.68,37.09,41.31,38.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M39,34.66a36,36,0,0,0-3.26-3.16c-.57-.5-1.16-1-1.77-1.43s-1.23-.88-1.85-1.34a14.27,14.27,0,0,1,5.57,4A9.88,9.88,0,0,1,39,34.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M40,34.88a6.71,6.71,0,0,1,.77-1.42,8.79,8.79,0,0,1,1-1.23,8.13,8.13,0,0,1,2.66-1.8L43.25,31.5c-.38.36-.76.71-1.13,1.08C41.38,33.31,40.68,34.08,40,34.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M38.8,30.37a3.11,3.11,0,0,1,.15-1,4.48,4.48,0,0,1,.4-.89,3.88,3.88,0,0,1,1.34-1.39c-.14.31-.3.57-.45.84l-.46.8C39.46,29.3,39.16,29.83,38.8,30.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M37.17,21.42a1.51,1.51,0,0,1,1.12-1.59,2.66,2.66,0,0,1-.2.48c-.07.14-.16.27-.24.4A3.46,3.46,0,0,1,37.17,21.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M36.8,21.67c-.49-.37-.92-.74-1.37-1.1L34.76,20c-.22-.19-.45-.37-.67-.59a3.32,3.32,0,0,1,1.66.75,4,4,0,0,1,.63.67A2.55,2.55,0,0,1,36.8,21.67Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M48.66,15.08s2.5-3.38,7.25-1.64c0,0-4.91,6.37-8.27,3.66Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M46.88,18.77a5.31,5.31,0,0,0-3.62-5.22s-.6,8.16,2.78,7.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M44.86,24.1s1.24-3.8,9.28-4.49c0,0-3.51,7.74-9.91,6.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M43.68,28.39S45,24.42,40.6,20c0,0-6.45,8.37,2.49,11.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M42.82,34a6.46,6.46,0,0,1,6.46-6.17S46,35.55,42.49,36.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M42.2,40.47a31.74,31.74,0,0,1,0-3.65c.09-1.21.2-2.42.36-3.63A49.71,49.71,0,0,1,44,26a49.09,49.09,0,0,1,2.46-6.89c.48-1.12,1-2.21,1.59-3.29s1.21-2.11,1.85-3.14C49,15,48,17.15,47.2,19.43S45.63,24,45,26.29s-1.2,4.66-1.68,7S42.46,38.06,42.2,40.47Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M42.49,34.28a7.34,7.34,0,0,1,.93-1.6,10.75,10.75,0,0,1,1.22-1.39,9.81,9.81,0,0,1,3.07-2.06c-.46.42-.94.79-1.39,1.19s-.9.81-1.33,1.23C44.12,32.48,43.3,33.36,42.49,34.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M43,30.34a7.46,7.46,0,0,1-1-1.55,10.69,10.69,0,0,1-.7-1.72,10,10,0,0,1-.44-3.67c.15.6.27,1.2.43,1.78s.31,1.17.49,1.74C42.11,28.07,42.52,29.2,43,30.34Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M45,25.62a8.1,8.1,0,0,1,1.25-1.37,10.88,10.88,0,0,1,1.49-1.11,9.71,9.71,0,0,1,3.43-1.36c-.54.3-1.09.56-1.61.87s-1.05.6-1.56.92C46.93,24.2,46,24.89,45,25.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M48.09,16.85a4.18,4.18,0,0,1,.85-.88,5.74,5.74,0,0,1,1-.66,5.47,5.47,0,0,1,2.34-.62c-.36.2-.72.36-1.07.54l-1,.52C49.49,16.1,48.82,16.48,48.09,16.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M46.13,20.16a4.15,4.15,0,0,1-.79-.93,6.19,6.19,0,0,1-.55-1.09,5.39,5.39,0,0,1-.38-2.39c.17.38.29.75.43,1.12L45.26,18C45.53,18.69,45.83,19.4,46.13,20.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M32.44,35.69H51.18s3.7,4.72-2,11.73H34.36A10,10,0,0,1,32.44,35.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M49.14,47.42H45.33c5.74-7,2.05-11.73,2.05-11.73h3.8S54.88,40.41,49.14,47.42Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-85",
    x1: 32.44,
    y1: 35.69,
    x2: 51.13,
    y2: 35.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-86",
    x1: 24.29,
    y1: 47.42,
    x2: 91.46,
    y2: 47.42
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    id: "stars"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M218.8,30.32l.73-1.88a.58.58,0,0,1,1.08,0l.65,1.91a5.41,5.41,0,0,0,2.94,3.28l1.75.78a.66.66,0,0,1,0,1.16l-1.79.7a5.44,5.44,0,0,0-3.07,3.16l-.74,1.88a.57.57,0,0,1-1.07,0l-.66-1.91a5.44,5.44,0,0,0-2.93-3.29l-1.76-.78a.65.65,0,0,1,0-1.15l1.78-.71A5.46,5.46,0,0,0,218.8,30.32Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M245.73,92.15l.48-1.23a.38.38,0,0,1,.71,0l.43,1.25a3.56,3.56,0,0,0,1.92,2.15l1.15.51a.43.43,0,0,1,0,.76l-1.18.46a3.6,3.6,0,0,0-2,2.07l-.48,1.23a.38.38,0,0,1-.71,0l-.42-1.26A3.61,3.61,0,0,0,243.68,96l-1.15-.51a.43.43,0,0,1,0-.76l1.17-.46A3.54,3.54,0,0,0,245.73,92.15Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M31.41,66.24,32,64.6a.5.5,0,0,1,.94,0l.6,1.64A4.69,4.69,0,0,0,36.15,69l1.53.64a.57.57,0,0,1,0,1l-1.53.64a4.69,4.69,0,0,0-2.6,2.79L33,75.74a.5.5,0,0,1-.94,0l-.6-1.64a4.69,4.69,0,0,0-2.6-2.79l-1.53-.64a.57.57,0,0,1,0-1L28.81,69A4.69,4.69,0,0,0,31.41,66.24Z"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    id: "coffee_table",
    "data-name": "coffee table"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M54.91,98.49h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M70.61,93.56c-3.42-1-10.09-1.76-17.77-1.76s-14.34.71-17.76,1.76H32.63v1.59c0,1.74,8,3.16,18.15,3.34h4.13c10.19-.18,18.14-1.6,18.14-3.34V93.56Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-13",
    cx: 52.84,
    cy: 93.57,
    rx: 20.21,
    ry: 3.35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M37.18,97.07h2.07a0,0,0,0,1,0,0v31.16a.85.85,0,0,1-.85.85H38a.85.85,0,0,1-.85-.85V97.07A0,0,0,0,1,37.18,97.07Z",
    transform: "translate(27.05 -5.76) rotate(13.31)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M68.18,97.07h.37a.85.85,0,0,1,.85.85v31.16a0,0,0,0,1,0,0H67.33a0,0,0,0,1,0,0V97.92A.85.85,0,0,1,68.18,97.07Z",
    transform: "translate(160.92 207.39) rotate(166.69)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M49.9,78.58A2.48,2.48,0,0,1,50,80.93h0a2.45,2.45,0,0,0,0,2.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M55.8,78.58a2.42,2.42,0,0,1,.08,2.35h0a2.45,2.45,0,0,0,0,2.28"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M52.85,78.58a2.48,2.48,0,0,1,.08,2.35h0a2.48,2.48,0,0,0,0,2.28"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-88"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-89"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 106.19,
    y1: 87.51,
    x2: 70.14,
    y2: 106.25
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 101.12,
    y1: 87.19,
    x2: 65.53,
    y2: 105.69
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 96.04,
    y1: 86.88,
    x2: 60.92,
    y2: 105.14
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 90.97,
    y1: 86.57,
    x2: 56.31,
    y2: 104.59
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 85.9,
    y1: 86.26,
    x2: 51.71,
    y2: 104.03
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 80.83,
    y1: 85.94,
    x2: 47.1,
    y2: 103.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 75.76,
    y1: 85.63,
    x2: 42.49,
    y2: 102.93
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 70.69,
    y1: 85.32,
    x2: 37.88,
    y2: 102.37
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 65.62,
    y1: 85.01,
    x2: 33.27,
    y2: 101.82
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 60.55,
    y1: 84.69,
    x2: 28.66,
    y2: 101.27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 55.48,
    y1: 84.38,
    x2: 24.05,
    y2: 100.72
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 50.41,
    y1: 84.07,
    x2: 19.45,
    y2: 100.16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 45.34,
    y1: 83.76,
    x2: 14.84,
    y2: 99.61
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 40.27,
    y1: 83.44,
    x2: 10.23,
    y2: 99.06
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 35.2,
    y1: 83.13,
    x2: 5.62,
    y2: 98.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 30.12,
    y1: 82.82,
    x2: 1.01,
    y2: 97.95
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 25.05,
    y1: 82.51,
    x2: -3.6,
    y2: 97.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-90",
    x1: 19.98,
    y1: 82.19,
    x2: -8.2,
    y2: 96.85
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M56.78,90.85a.29.29,0,0,1-.28-.21.28.28,0,0,1,.2-.36s3.68-1.08,3.68-3.08a1,1,0,0,0-.33-.83,2.16,2.16,0,0,0-1.6-.17.31.31,0,0,1-.36-.22.3.3,0,0,1,.22-.35,2.79,2.79,0,0,1,2.09.28A1.54,1.54,0,0,1,61,87.2c0,2.43-3.94,3.59-4.1,3.63Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M59.76,92.09a.23.23,0,0,1,.13.43,6.77,6.77,0,0,1-1.38.67,7,7,0,0,1-2.3.38H49.64a6.84,6.84,0,0,1-3.68-1,.24.24,0,0,1,.13-.43Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-91"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M57.68,92.09c0,.45-2.13,1-4.75,1s-4.75-.6-4.75-1Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M56.18,91.45c2.75-2.32,2.32-6.32,2.32-6.32H47.13s-.44,4,2.32,6.32a5.19,5.19,0,0,0,3.36,1.19h0A5.22,5.22,0,0,0,56.18,91.45Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-48",
    cx: 52.81,
    cy: 85.13,
    rx: 5.68,
    ry: 0.17
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.ac2ab065cc2f651fe62f22613fd5c4ee.svg";
export { ForwardRef as ReactComponent };